/**
 * Convert Unix timestamp to "March 01, 2025" format
 * @param timestamp - Unix timestamp as string (e.g., "1768413601.00000000")
 * @returns Formatted date string (e.g., "March 01, 2025")
 */
export const formatPatrolDate = (timestamp: string): string => {
  const date = new Date(parseFloat(timestamp) * 1000);
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "2-digit",
    year: "numeric",
    timeZone: "UTC",
  });
};

/**
 * Convert Unix timestamp to "HH:MM" UTC format
 * @param timestamp - Unix timestamp as string (e.g., "1768413601.00000000")
 * @returns Formatted time string in 24-hour format (e.g., "14:30")
 */
export const formatPatrolTime = (timestamp: string): string => {
  const date = new Date(parseFloat(timestamp) * 1000);
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "UTC",
  });
};
